import React from 'react';
import SingleValueIcon from '@splunk/dashboard-visualizations/SingleValueIcon';

export default () => (
    <SingleValueIcon
        options={{}}
        encoding={{
            trend: 'primary.foo',
            icon: {
                field: 'primary[0]',
                format: {
                    type: 'rangevalue',
                    ranges: [
                        {
                            from: 1560,
                            value: 'default',
                        },
                        {
                            from: 70,
                            to: 1560,
                            value: 'star',
                        },
                        {
                            from: 30,
                            to: 70,
                            value: 'pencil',
                        },
                        {
                            from: 0,
                            to: 30,
                            value: 'clock',
                        },
                        {
                            to: 0,
                            value: 'activity',
                        },
                    ],
                },
            },
        }}
        dataSources={{
            primary: {
                data: {
                    columns: [
                        ['1', '62', '103', '308', '587', '876', '930', '1320'],
                        [
                            '2018-08-19T00:00:00.000+00:00',
                            '2018-08-20T00:00:00.000+00:00',
                            '2018-08-21T00:00:00.000+00:00',
                            '2018-08-22T00:00:00.000+00:00',
                            '2018-08-23T00:00:00.000+00:00',
                            '2018-08-24T00:00:00.000+00:00',
                            '2018-08-25T00:00:00.000+00:00',
                            '2018-08-26T00:00:00.000+00:00',
                        ],
                    ],
                    fields: [
                        {
                            name: 'foo',
                        },
                        {
                            name: '_time',
                        },
                    ],
                },
                meta: {},
            },
        }}
    />
);
